<template>
    <app-layout>
        <template #header>
            <h2 class="text-xl font-semibold leading-tight text-gray-800">Kasutajad</h2>
        </template>

        <div class="py-12">

          <div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div class="p-6 overflow-hidden bg-white shadow sm:rounded">

              <div class="p-float-label w-full mb-10" key="specialist">
                  <auto-complete
                      id="specialist"
                      placeholder=" "
                      v-model="specialist"
                      :suggestions="filteredSpecialist"
                      field="name"
                      class="w-full"
                      scrollHeight="150px"
                      @complete="searchSpecialist($event)"
                      @clear="clearSearchSpecialist($event)"
                      @item-select="searchQualifications($event)">
                    <template #item="slotProps">
                      <div>{{ slotProps.item.name }}</div>
                    </template>
                  </auto-complete>
                  <label for="project" class="text-blue-500 uppercase">Spetsialist</label>
                </div>

              <DataTable :value="users" :expandedRows.sync="expandedRows" :loading="loading"
                         dataKey="id" responsiveLayout="scroll"
                         @row-expand="onRowExpand">
                <Column :expander="true" :headerStyle="{'width': '3rem'}" />
                <Column field="id" headerStyle="width:9%" header="ID" sortable>
                  <template #body="slotProps">
                    {{ slotProps.data.id }}
                  </template>
                </Column>
                <Column field="name" header="Nimi" sortable>
                  <template #body="slotProps">
                    {{ slotProps.data.name }}
                  </template>
                </Column>
                <Column field="phone" header="Telefon" sortable>
                  <template #body="slotProps">
                    {{ slotProps.data.phone ? (slotProps.data.phoneCode ? '+' + slotProps.data.phoneCode : '') + slotProps.data.phone : ''}}
                  </template>
                </Column>
                <Column field="email" header="Email" sortable>
                  <template #body="slotProps">
                    {{ slotProps.data.email }}
                  </template>
                </Column>
                <Column field="role" header="Roll" sortable>
                  <template #body="slotProps">
                    {{
                      slotProps.data.active_roles && slotProps.data.active_roles.length > 0
                      && slotProps.data.active_roles.map(x => x.display_name).join(', ')
                    }}
                  </template>
                </Column>
                <template #expansion="slotProps">
                  <div class="project-users-subtable bg-gray-200 p-3 rounded">

                    <div>
                      <div>
                        <Dialog :visible.sync="updateDialog.show" modal :closable="true">
                          <div class="max-w-lg p-4 text-center md:p-8">
                            <icon name="help" width="119" height="119" vbWidth="119" vbHeight="119" stroke="none" class="mb-8 md:mb-12" />
                            <h3 class="mb-4 text-2xl font-semibold">Oled kindel, et soovid kutseid uuendada?</h3>
                            <button class="w-64 mt-8 text-white uppercase bg-blue-400 btn md:mt-12" @click="update(updateDialog.id)">
                              Kinnitan
                            </button>
                            <button class="w-64 mt-8 text-white uppercase bg-orange-400 btn md:mt-12" @click="cancelUpdate()">
                              Loobun
                            </button>
                          </div>
                        </Dialog>


                        <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded my-3"
                                @click="showUpdateDialog(slotProps.data.id)">
                          Uuenda Kutsekojast
                        </button>
                      </div>

                      <div>
                        <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded my-3"
                                @click="showAddNewQualification(slotProps.data)">Lisa uus
                        </button>
                      </div>
                    </div>

                    <DataTable :value="slotProps.data.extra">
                      <Column field="id"
                              header="ID"
                              headerStyle="width:5%"
                              sortable>
                        <template #body="childSlotProps">
                          {{ childSlotProps.data.id }}
                        </template>
                      </Column>
                      <Column field="levelName" header="Kutsenimetus" sortable>
                        <template #body="childSlotProps">
                          {{ childSlotProps.data.level.name }}
                        </template>
                      </Column>
                      <Column field="gfLevel"
                              header="Qf level"
                              headerStyle="width:8%"
                              sortable>
                        <template #body="childSlotProps">
                          {{ childSlotProps.data.qf_level }}
                        </template>
                      </Column>
                      <Column field="qfId"
                              header="Qf ID"
                              headerStyle="width:10%"
                              sortable>
                        <template #body="childSlotProps">
                          {{ childSlotProps.data.qf_id }}
                        </template>
                      </Column>
                      <Column field="specialization" header="Spetsialiseerumine" sortable>
                        <template #body="childSlotProps">
                          {{ childSlotProps.data.specialization }}
                        </template>
                      </Column>
                      <Column field="levelArea"
                              header="Valdkond"
                              style="word-wrap: break-word"
                              sortable>
                        <template #body="childSlotProps">
                          {{ childSlotProps.data.level.area_id ? Area.getName(childSlotProps.data.level.area_id) : ''}}
                        </template>
                      </Column>
                      <Column field="levelIsLead"
                              header="Vastutav"
                              headerStyle="width:10%"
                              sortable>
                        <template #body="childSlotProps">
                          {{ childSlotProps.data.level.is_lead === 0 ? 'NON_LEAD' : 'LEAD' }}
                        </template>
                      </Column>
                      <Column field="from"
                              header="Väljastaja"
                              headerStyle="width:10%"
                              sortable>
                        <template #body="childSlotProps">
                          {{ childSlotProps.data.qualification_issuer.name }}
                        </template>
                      </Column>
                      <Column field="actions"
                              header="Tegevus"
                              headerStyle="width:10%"
                              sortable>
                        <template #body="childSlotProps">
                          <div v-if="childSlotProps.data.qualification_issuer.id === QualificationIssuer.IFFENT">
                            <a @click="deleteQualification(slotProps, childSlotProps)" class="text-lg hover:text-blue-500 flex items-center">
                              <div
                                  class="pi pi-minus-circle w-6 h-6 bg-blue-100 rounded-full mr-3 flex items-center justify-center text-xs text-red-500 font-semibold">
                              </div>
                              Kustuta
                            </a>
                          </div>
                        </template>
                      </Column>
                    </DataTable>
                  </div>
                </template>
              </DataTable>

              <Dialog :visible.sync="display.show" :style="{width: '35vw'}" :closeOnEscape="true" @hide="closeModal()">
                <template #header>
                  <h3 class="text-xl font-semibold">Kutse lisamine</h3>
                </template>

                <h4 class="text-sm text-blue-500 uppercase">Valdkond</h4>
                <span class="p-float-label">
                          <dropdown
                              v-model="area"
                              :options="allAreas"
                              option-label="name"
                              @change="changeLevels(area.id)"
                              class="w-full text-gray-900"
                          />
                        </span>

                <h4 class="text-sm text-blue-500 uppercase">Kutsenimetus</h4>
                <span class="p-float-label">
                          <dropdown
                              v-model="selectedLevel"
                              :options="levels"
                              option-label="name"
                              class="w-full text-gray-900"
                          />
                        </span>

                <div class="py-20"/>

                <template #footer>
                  <Button type="button"
                          class="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
                          @click="closeModal()">Katkesta
                  </Button>
                  <Button type="button"
                          class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                          @click="save(display.user)">Lisa
                  </Button>
                </template>
              </Dialog>

            </div>
          </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from './../../Layouts/AppLayout'
import {addQualification, deleteQualification, getAreaLevels, searchAllActiveUsers, searchAllUsers, searchUserQualifications, updateQualifications} from "../../store/admin.api";
import {Area} from "../../utils/area";
import {QualificationIssuer} from "../../utils/qualification.issuer";
import {getAllAreas} from "@/store/admin.api";

export default {
    components: {
        AppLayout
    },
    data() {
        return {
            users: null,
            loading: false,
            specialist: null,
            filteredSpecialist: null,
            qualifications: null,
            display: {
              show: false,
              user: null
            },
            area: null,
            allAreas:[],
            levels: null,
            selectedLevel: null,
            updateDialog: {
              show: false,
              id: null
            },
            expandedRows: []
        }
    },
    computed: {
      Area() {
        return Area;
      },
      QualificationIssuer() {
        return QualificationIssuer;
      }
    },
    methods: {
        searchSpecialist(event) {
          searchAllUsers(event.query)
          .then(response => {
            this.filteredSpecialist = response.data
          })
        },
        clearSearchSpecialist() {
          this.filteredSpecialist = null;
          this.searchAll();
        },
        searchQualifications(event) {
          this.users = [event.value];
        },
        refreshQualifications(user) {
          this.loading = true;
          searchUserQualifications(user.id)
          .then(response => {
            user.extra = response.data;
            this.loading = false;
          }, () => {
            this.showToast('Kasutaja kutsete laadimine ebaõnnestus', 'error');
            this.loading = false;
          })
        },
        onRowExpand(event) {
          this.loading = true;
          searchUserQualifications(event.data.id)
          .then(resp => {
            event.data.extra = resp.data;
            this.loading = false;
          }, () => {
            this.showToast('Kasutaja laadimine ebaõnnestus', 'error');
            this.loading = false;
          })
        },
        closeModal() {
            this.display.user = null
            this.display.show = false
            this.reset()
        },
        reset() {
            this.area = null;
            this.selectedLevel = null;
        },
        changeLevels(areaId) {
          getAreaLevels(areaId, QualificationIssuer.IFFENT)
            .then(response => {
              this.levels = response.data;
            }, (error) => {
              const toast = error.response?.data;
              if (toast) {
                this.processAxiosPositiveResponse(toast);
              } else {
                this.$toast.add({
                  severity: 'error',
                  summary: "Kutsenimetuste pärimine ebaõnnestus",
                  life: 3000,
                  closable: false
                })
              }
            });
        },
        deleteQualification(user, qualification) {
          deleteQualification(qualification.data.id).then(response => {
            this.processAxiosPositiveResponse(response.data);
            this.refreshQualifications(user.data);
          })
          .catch(function(){
            this.$toast.add({
              severity: 'error',
              summary: "Kvalifikatsiooni kustutamine ebaõnnestus",
              life: 3000,
              closable: false
            })
          });
        },
        showAddNewQualification(user) {
          this.display.user = user;
          this.display.show = true;
        },
        async save(user) {

            if (!user) {
              this.$toast.add({
                severity: 'warn',
                summary: "Kasutaja on valimata",
                life: 3000,
                closable: false
              })
            }

            await addQualification(user.id, this.selectedLevel).then((res) => {
              this.processAxiosPositiveResponse(res.data);
              this.reset();
              this.closeModal();
              this.refreshQualifications(user);
            }, (error) => {
              error.response.data.text().then(text => {
                const toast = JSON.parse(text);
                this.processAxiosPositiveResponse(toast);
              });
            });
        },
        showUpdateDialog(id) {
          this.updateDialog.show = true;
          this.updateDialog.id = id;
        },
        cancelUpdate() {
          this.updateDialog.show = false;
          this.updateDialog.id = null;
        },
        update(id) {
          updateQualifications(id).then((res) => {
            this.processAxiosPositiveResponse(res.data);
            this.updateDialog.show = false;
            this.updateDialog.id = null;
          });
        },
        searchAll() {
          searchAllActiveUsers().then((resp) => {
            this.users = resp.data;
          }, (error) => {
            error.response.data.text().then(text => {
              const toast = JSON.parse(text);
              this.processAxiosPositiveResponse(toast);
            });
          });
        },
    },
    async mounted() {
      this.searchAll();
      getAllAreas().then((resp) => {
        this.allAreas = resp.data;
      });
    },
}
</script>
